import { BimType } from "@aec-craft/nb-generative-core";
import { z } from "zod";
import { zRV3 } from "./z-rv3";

export const zBimObjectJson = z
	.object({
		version: z.number(),
		id: z.string().min(1),
		type: z.nativeEnum(BimType),
		isTemplate: z.boolean(),
		name: z.string(),
		position: zRV3,
		size: zRV3,
		anchor: zRV3,
		rotation: zRV3,
		children: z.array(z.string()),
		templateId: z.string().optional(),
		parentTemplate: z.string().optional(),
	})
	.passthrough();

export const zRootBimObjectJson = z.object({
	record: z.record(z.string(), zBimObjectJson),
	root: z.string().uuid(),
});
